import './Footer.css';

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer__container'>
        <p className='footer__text'>
          &copy; 2024 Taylor-Made. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
